import type {
	RegisteredRouter,
	RouteIds,
	SearchParamOptions
} from "@tanstack/react-router";

import { sanitizeParams } from "@/lib/utils";
import {
	getRouteApi
} from "@tanstack/react-router";

export function useFilters<
	TId extends RouteIds<RegisteredRouter["routeTree"]>,
	TSearchParams extends SearchParamOptions<
		RegisteredRouter,
		TId,
		TId
	>["search"]
>(routeId: TId) {
	const routeApi = getRouteApi<TId>(routeId);
	const navigate = routeApi.useNavigate();
	const filters = routeApi.useSearch();

	const setFilters = (partialFilters: Partial<TSearchParams>) => {
		const newFilters = sanitizeParams({
			...filters,
			...partialFilters
		});
		navigate({
			search: newFilters as TSearchParams
		});
	};

	const resetFilters = () => navigate({ search: true });

	return { filters, setFilters, resetFilters };
}
